module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_vm._v("Menu Ideas")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Whether you realize it or not, every dining occasion has a theme. That theme may be a wedding reception for 200, a romantic dinner for two, Thanksgiving for the whole family, or \"whatever-I-can-grab-from-the-fridge-and-make in-30-minutes,\" but there is always some unifying objective that brings recipes together to make a meal. Here are some meal themes we've fleshed out using the recipes in this book. Use them as a guideline, a starting point, or a springboard for your own cooking imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "heading-1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Reasons To Celebrate")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Thanksgiving Feast")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Vegetable Cornucopias With Gravy")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taste Of Autumn Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chestnut Stuffing")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double Cranberry Chutney")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cranberry-Cherry Lattice Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Christmas Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rich And Creamy Eggnog")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cranberry-Pecan Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winter Squash With Spicy Maple Chestnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Beans With Walnuts And Shallot Crisps")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pomegranate-Pineapple Granita")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thumbprint Cookies")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kourabiedes ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Almond Shortbread Crescents")]), _vm._v(")")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snickerdoodles")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iced Ginger Gems")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("New Year's Eve Dinner Party")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New World Party Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\"Wild\" Mushroom Soup With Sage And Croutons")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twice-Cooked Polenta Wedges With Black-Eyed Pea Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Triple Nut Chocolate Tart")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("New Year's Day Brunch")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twice-Cooked Polenta Wedges With Black-Eyed Pea Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southwestern Tofu Scramble")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh Bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morning Glory Loaf")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Super Bowl Sunday Get-Together")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Root Vegetable Chili Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double-Corn Cornbread")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taste Of Autumn Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chinese New Year Supper")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Avocado Vietnamese Summer Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fiery Tofu With Red Chiles, Orange, And Ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinese Broccoli With Black Bean Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("East-West Risotto")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Mardi Gras Buffet")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seitan Jambalaya")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep South Slaw")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Pound Cake With Lime Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Valentine's Day Tête à Tête")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Apple-Potato Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Tofu Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beet Green–Tangerine Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Truffles")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("St. Patrick's Day Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunset Sweet Potato Drop Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colcannon")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three-Cherry Crumble")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Passover Seder")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quinoa And Spinach Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sephardic Stuffed Cabbage")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Leek And Sweet Potato Gratin")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Strawberry Compote With Vanilla Bean")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Easter Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Garlic Hummus")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muhammara")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring Vegetable Stew With Soft Polenta")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Radicchio, Radish, And Fennel Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Pound Cake With Lime Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cinco de Mayo Celebration")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mango Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oaxacan Clayudas")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refried Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chili Sin (Without) Carne")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Mother's Day Brunch")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Carrot-Ginger Bisque")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orzo With Peas And Asparagus")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lebanese Chickpea Croquettes")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tofu Custard Tart With Fresh Fruit")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bridal Shower")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watermelon Slushies (For Grown-Ups)")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muhammara")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Bean And Watercress Tartines")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Heart Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Wedding Reception")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Olive Tapenade")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artichoke Tapenade")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Asparagus Tapenade")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Red Pepper Crostini With Balsamic Reduction")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chive And Walnut \"Cheese\" Bites")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Tempura With Chile Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seitan Satay With Peanut Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh Larb")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maki Garden Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pickled Daikon Cubes With Carrots And Jalapeños")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fourth of July Cookout")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh-Mushroom Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato Salad With Apple And Avocado")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collard Green Coleslaw")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter–Oatmeal Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Halloween Potluck")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Onion Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pepper-Crusted Cashew \"Goat\" Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creepy Halloween \"Finger\" Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moroccan Pumpkin And Lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snickerdoodles")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Kid's Birthday Party")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Hot Chocolate Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gluten-Free Veggie Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlicky Oven Fries")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glazed Chocolate-Avocado Cupcakes")])]), _vm._v(" "), _c('p', {
    staticClass: "heading-1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Global Goodness")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sushi Party")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maki Garden Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scattered Brown Rice Sushi Bowls")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soba Salad With Miso Vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Tempura With Chile Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Caribbean Creations")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sorrel Drink")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Callaloo With Hot Pepper Vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jamaican Tempeh Patties")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Italian Extravaganza")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carciofi Alla Romana ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Roman-Style Braised Artichokes")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Vegetable Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\"Meat\" Balls And Spaghetti")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greek Feast")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dolmades ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Stuffed Grape Leaves")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegan Moussaka")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kourabiedes ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Almond Shortbread Crescents")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Taste of Thai")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mock Green Papaya Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh Larb")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thai Red Curry")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thai Golden Curry")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Korean Cuisine")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chilled Tofu Salad With Ginger, Green Onions, Asparagus, And Sesame")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pickled Daikon Cubes With Carrots And Jalapeños")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forbidden Rice Stove-Top Bibimbap")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Korean BBQ Marinade")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Moroccan Spice Market")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warm Pitas With Dukka")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moroccan Harira")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tofu With Olives And Preserved Lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Vive la France!")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perfect Steamed Artichokes a la Française")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh Bourguignonne")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Radicchio, Radish, And Fennel Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple-Cinnamon Tarte Tatin")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Indian Sensations")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curried Lentils With Cauliflower")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Cardamom Rice Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "heading-1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Everyday Occasions")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sunday Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Breakfast Quinoa With Dried Fruit")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tofu Frittata With Zucchini And Onion")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Kiwi Jam")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bag Lunch")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paprika Cauliflower Pita Pockets")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn And Mung Bean Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Heart-Healthiest Chocolate Chip Cookies In The World")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Weeknight Dinner")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seitan With Shiitake Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunshine Spinach Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "unnumbered"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter–Coconut Ice Cream")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad6e0a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780470547885f05.vue
// module id = 75
// module chunks = 0